export default __webpack_public_path__ + "static/media/image10.a132d42d.jpg";